var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-header",class:_vm.isSafari ? 'safari' : ''},[_c('div',{staticClass:"mobile-header__logo"},[_c('MenuLogo')],1),_c('div',{staticClass:"mobile-header__icon",class:_vm.isSafari ? 'safari' : '',on:{"click":function($event){return _vm.handleSidebar()}}},[_c('MobileIcon')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }